<template>
    <div>
        <MainNavigation page-name="My Class" :routeIndex="routeIndex" />
        <NotificationBar msg-text="Edit your student list" />
        <Loader v-if="!currentClass" />
        <section v-if="currentClass">
            <div>
                <h2>Class Info</h2>
            </div>
            <div :class="
          'class-item static ' + $filters.colorAssign(currentClass.classId)
        ">
                <div>
                    <h2 class="class-nickname">
                        {{ currentClass.classInfo.nickname }}
                    </h2>
                    <p class="class-title">
                        {{ currentClass.classInfo.subject }}
                    </p>
                    <ul id="example-1">
                        <li v-for="(newDay, idx) in currentClass.classInfo.checkedDay" :key="idx">
                            {{ newDay
                            }}{{
                            idx == currentClass.classInfo.checkedDay.length - 1 ? "" : "|"
                            }}
                        </li>
                    </ul>
                </div>
            </div>
            <hr />
            <div style="text-align: left">
                <h2>Edit Student List</h2>
                <p>
                    Edit student names or nicknames, add new students, or archive their
                    entries.
                    <br />
                    Students will see their nicknames instead of their names in the
                    app.
                </p>
            </div>
            <p v-if="validArray.filter((item) => item > 0).length != 0" style="
          display: flex;
          font-weight: bold;
          font-width: 16px;
          color: #eb5757;
        ">
                See errors below.
            </p>
            <div v-if="validArray.filter((item) => item > 0).length != 0"
                :class="{ error: validArray.filter((item) => item > 0).length != 0 }" style="padding: 1rem">
                <!-- Duplicate name with no nickname -->
                <p v-if="validArray.includes(1)" class="error-message">
                    <img src="@/assets/error_outline_24px.svg" class="error-icon" />
                    Student must have unique names. Please remove duplicate names.
                </p>

                <!-- Duplicate name with same nickname -->
                <p v-if="validArray.includes(2)" class="error-message">
                    <img src="@/assets/error_outline_24px.svg" class="error-icon" />
                    For students with identical names, add a unique nickname.
                </p>

                <!-- Invalid name format -->
                <p v-if="validArray.includes(3)" class="error-message">
                    <img src="@/assets/error_outline_24px.svg" class="error-icon" />
                    Names must use this format: First name and last initial (e.g., John D)
                </p>
            </div>
            <ul class="student-list">
                <li v-for="(student, index) in allStudents" :key="index" :class="{ error: validArray[index] != 0 }">
                    <div class="student-form">
                        <h4>Student {{ index + 1 }}</h4>
                        <span class="material-icons-round button" @click="removeStudent(index)">remove_circle</span>
                    </div>

                    <div class="name-inputs">
                        <input type="text" maxlength="35" placeholder="First name" v-model="student.studentFirstName" />
                        <input type="text" maxlength="1" placeholder="Last initial"
                            v-model="student.studentLastInitial" />
                    </div>

                    <div v-if="student.isNickNameOpen">
                        <div class="student-form">
                            <h4>Nickname</h4>
                            <span class="material-icons-round button"
                                @click="closeNickname(student)">remove_circle</span>
                        </div>
                        <div class="nickname-form">
                            <input type="text" maxlength="35" placeholder="Nickname" v-model="student.studentNickname" />
                        </div>
                    </div>
                    <button style="margin: 1rem 0" class="add-nickname-button" v-if="!student.isNickNameOpen"
                        @click="student.isNickNameOpen = true">
                        <span class="material-icons-round">add_circle</span>
                        Add a Nickname
                    </button>
                </li>
            </ul>

            <div class="add-student" style="margin-bottom: 2rem">
                <button @click="addAStudent()" class="add-student-button">
                    <span class="material-icons-round">add_circle</span>
                    <span>Add a Student</span>
                </button>
            </div>

            <button class="save-button" @click="checkIfValid()">Save</button>

            <Modal v-show="isModalVisible" @close="closeModal">
                <template v-slot:header> <b>Confirm Archiving</b> </template>
                <template v-slot:body>
                    You are archiving
                    <b>{{ studentToArchive ? studentToArchive.studentName : "" }}</b>. You will still be able to
                    view
                    their past report cards, but you
                    <b>will not be able to restore them to your class list</b>.
                </template>

                <template v-slot:footer>
                    <div class="modal-button-group">
                        <button class="cancel-button" @click="closeModal">Cancel</button>
                        <button @click="confirmArchiveStudent">Archive</button>
                    </div>
                </template>
            </Modal>
        </section>
    </div>
</template>

<script>
    import MainNavigation from "../components/MainNavigation.vue";
    import NotificationBar from "../components/NotificationBar.vue";
    import Modal from "../components/Modal.vue";
    import Loader from "../components/Loader.vue";
    export default {
        name: "EditStudentList",
        components: {
            MainNavigation,
            NotificationBar,
            Modal,
            Loader,
        },
        props: ["name", "routeIndex"],
        data() {
            return {
                studentEntry: null,
                studentNumber: 0,
                showStudentList: true,
                studentToArchive: null,
                isModalVisible: false,
            };
        },
        mounted() {
            this.classList.forEach(student => {
                if (student.studentName && (!student.studentFirstName || !student.studentLastInitial)) {
                    const parts = student.studentName.trim().split(/\s+/);
                    student.studentFirstName = parts[0];
                    student.studentLastInitial = parts[1];
                }
                // Auto-open nickname fields if a nickname exists
                if (student.studentNickname) {
                    student.isNickNameOpen = true;
                }
            });
        },
        computed: {
            classList() {
                return this.currentClass.studentList;
            },
            allClasses() {
                return this.$store.state.allClasses;
            },
            currentClass() {
                for (let i = 0; i < this.$store.state.allClasses.length; i++) {
                    const thisClass = this.$store.state.allClasses[i];
                    if (thisClass.classInfo.nickname == this.$route.params.name) {
                        return this.$store.state.allClasses[i];
                    }
                }
                return {
                    classId: null,
                    classInfo: {
                        nickname: null,
                        checkedDay: [],
                        grade: null,
                        subject: null,
                    },
                    studentList: [],
                };
            },
            allStudents() {
                return this.currentClass.studentList;
            },
            validArray() {
                const tempArray = Array(this.classList.length).fill(0);

                // Check format: First name + Last Initial (e.g. John D)
                for (let i = 0; i < this.classList.length; i++) {
                    const student = this.classList[i];

                    const first = student.studentFirstName;
                    const last = student.studentLastInitial;

                    // Check empty name
                    if (!first && !last) {
                        tempArray[i] = 0;
                        continue;
                    }

                    const firstNameValid = /^[a-zA-Z][a-zA-Z'’-]*$/.test(first);
                    const lastInitialValid = /^[a-zA-Z]$/.test(last);

                    if (!firstNameValid || !lastInitialValid) {
                        tempArray[i] = 3;
                    }
                }

                // Check for duplicate names and nicknames
                for (let i = 0; i < this.classList.length; i++) {
                    const s1 = this.classList[i];
                    const name1 = `${s1.studentFirstName} ${s1.studentLastInitial}`;

                    for (let j = i + 1; j < this.classList.length; j++) {
                        const s2 = this.classList[j];
                        const name2 = `${s2.studentFirstName} ${s2.studentLastInitial}`;

                        if (name1 === name2 && s1.studentFirstName && s2.studentFirstName) {
                            if (s1.studentNickname && s2.studentNickname && s1.studentNickname === s2.studentNickname) {
                                tempArray[i] = tempArray[j] = 2; // duplicate names + duplicate nicknames
                            } else if (!s1.studentNickname && !s2.studentNickname) {
                                tempArray[i] = tempArray[j] = 1; // duplicate names + no nicknames
                            }
                        }
                    }
                }
                return tempArray;
            },
        },
        methods: {
            checkIfValid: function () {
                this.classList.forEach(s => {
                    s.studentFirstName = (s.studentFirstName || "").trim();
                    s.studentLastInitial = (s.studentLastInitial || "").trim();
                    s.studentNickname = (s.studentNickname || "").trim();
                });

                let flag = true;

                // Any format or duplicate errors?
                if (this.validArray.includes(3)) flag = false;
                if (this.validArray.filter(item => item > 0).length !== 0) flag = false;

                // Any students missing first name or last initial?
                if (this.classList.some(item => item.studentFirstName === "" || item.studentLastInitial === "")) {
                    flag = false;
                }

                // No students at all?
                if (this.classList.length == 0) flag = false;

                if (flag) this.saveClass();
            },
            saveClass: function () {
                const studentListFormatted = this.classList.map(s => ({
                    ...s,
                    studentFirstName: s.studentFirstName,
                    studentLastInitial: s.studentLastInitial,
                    studentName: `${s.studentFirstName} ${s.studentLastInitial}`
                }));

                this.$store.commit("SEND_MESSAGE", {
                    data: {
                        studentList: studentListFormatted,
                        classId: this.currentClass.classId,
                    },
                    opCode: this.$store.state.opCodes.UpdateClassStudentList,
                });
                this.$store.commit("SEND_MESSAGE", {
                    data: this.currentClass.classId,
                    opCode: this.$store.state.opCodes.PastSessionsCount,
                });
                this.$router.push({
                    name: "class-info",
                    params: { name: this.currentClass.classInfo.nickname },
                }).then(()=> {
                    window.location.reload();
                });
            },
            addAStudent() {
                this.studentNumber++;
                this.classList.push({
                    isNickNameOpen: false,
                    studentName: "",
                    studentFirstName: "",
                    studentLastInitial: "",
                    studentNickname: "",
                });
            },
            closeNickname(student) {
                student.isNickNameOpen = false;
                student.studentNickname = "";
            },

            archiveStudent(index) {
                if (this.classList[index].archived == true) {
                    this.classList[index].archived = false;
                } else {
                    this.studentToArchive = this.classList[index];
                    this.showModal();
                }
            },
            showModal() {
                this.isModalVisible = true;
            },
            closeModal() {
                this.isModalVisible = false;
            },
            confirmArchiveStudent() {
                this.classList[
                    this.classList.indexOf(this.studentToArchive)
                ].archived = true;
                this.closeModal();
            },
            removeStudent(index) {
                this.classList.splice(index, 1);
                this.studentNumber--;
            },
        },
    };
</script>

<style>
    /* /* ../assets/scss/_student-list.scss */
</style>